import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import journal from '@/api/journal'
import operation from '@/api/operation'
import Add from '../add.dialog.vue'
import Detail from './detail.dialog.vue'
import { eboardApply } from '@/api/eboard'
// import section from '@/api/section'
import SendEmail from '@/views/editorial-office/manuscripts/dialog/send-email.dialog'
const columns = [
  {
    title: '',
    enTitle: 'Email',
    width: 200,
    dataIndex: 'email',
    slot: 'omis',
  },
  {
    title: '',
    enTitle: 'Name',
    width: 120,
    dataIndex: 'Name',
    slot: 'name',
  },
  {
    title: '',
    enTitle: 'Affiliations',
    width: 200,
    dataIndex: 'affiliation',
    slot: 'omis',
  },
  {
    title: '',
    enTitle: 'Identity',
    width: 200,
    dataIndex: 'identityCode',
    slot: 'roles',
  },
  {
    title: '',
    enTitle: 'Status',
    width: 100,
    dataIndex: 'handle',
    slot: 'status',
  },
  {
    title: '',
    enTitle: 'Operator',
    width: 120,
    dataIndex: 'operator',
    slot: 'operator',
  },
  {
    title: '',
    enTitle: 'Apply Time',
    width: 150,
    dataIndex: 'createTime',
    slot: 'date',
  },
  {
    title: '',
    enTitle: 'Processing Time',
    width: 150,
    dataIndex: 'dealTime',
    slot: 'date',
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 150,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions',
  },
]
export default {
  components: {
    SiteSearchGroup,
    Add,
    Detail,
    SendEmail,
  },
  data() {
    return {
      columns,
      isVisable: false,
      isVisableDetail: false,
      showSendEmail: false,
      journalList: [],
      // sections: [],
      dataSource: [],
      inputData: {},
      params: {
        handle: '',
        journalId: '',
      },
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true,
      },
      emailData: {},
      emailHandle: '',
      updateDate: {},
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      country: 'getCountry',
      editorialBoard: 'getEditorialBoard',
      user: 'getUser',
    }),
  },
  async mounted() {
    await this.getJournalList()
  },
  methods: {
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size,
      })
      const { list, pageIndex, pageSize, total } = await eboardApply.get(data)
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex,
      })
    },
    async getJournalList() {
      this.journalList = await journal.userGet()
      const flag = this.journalList.some((item) => {
        if (item.id === localStorage.getItem('journalId')) {
          this.params.journalId = item.id
          return true
        }
      })
      if (!flag) {
        this.params.journalId = this.journalList[0] && this.journalList[0].id
        localStorage.setItem('journalId', this.params.journalId)
      }
      this.getList()
    },
    changeStatus(status) {
      this.params.handle = status
      this.getList()
    },
    async edit(val) {
      // this.sections = await section.getAll({ journalId: this.params.journalId })
      this.inputData = JSON.parse(JSON.stringify(this.params))
      this.$refs['editorial-board-add'].getQuery(val.id, {
        journalId: this.params.journalId,
        apply: true,
      })
      this.isVisable = true
    },
    async able(val, handle) {
      const { id, version } = val
      await eboardApply.accepted(
        id,
        Object.assign(val, {
          handle,
          version,
        })
      )
      let content = `This Editorial Board has been ${handle.toLowerCase()}!`
      this.$message.success({
        title: 'Success',
        content: content,
      })
      this.getList()
    },
    handleClear() {
      this.params.keyword = ''
    },
    async accept(val, handle) {
      this.$confirm({
        title: `Are you sure you want to ${
          handle === 'ACCEPTED' ? 'accept' : 'reject'
        } this application?`,
        content: `Please be aware of once this application is ${handle.toLowerCase()}, the candidate will receive an notification email.`,
        type: handle === 'ACCEPTED' ? 'success' : 'danger',
        icon: handle === 'ACCEPTED' ? 'iconAble' : 'iconDetails',
        confirmText: handle === 'ACCEPTED' ? 'Accept' : 'Reject',
      }).then(async () => {
        // this.sendEmail(val)
        // this.emailData = val
        // this.emailHandle = handle
        const data = await eboardApply.query(val.id, {
          journalId: this.params.journalId,
        })
        await eboardApply.acceptedById(
          val.id,
          Object.assign(data, { handle, journalId: this.params.journalId })
        )
        if (handle === 'ACCEPTED') {
          await operation.add({
            authorityCode: 'WEBSITE.EDITOR_BOARD.APPLY.ACCEPT',
            type: 'ACCEPT',
            info: `Editorial Board Application - Accept: ${val.email}`,
            detail: `【Email】: ${val.email}<br/>
            【Name】: ${val.firstName} ${val.lastName}`,
          })
        } else {
          await operation.add({
            authorityCode: 'WEBSITE.EDITOR_BOARD.APPLY.REFUSE',
            type: 'REFUSE',
            info: `Editorial Board Application - Refuse: ${val.email}`,
            detail: `【Email】: ${val.email}<br/>
            【Name】: ${val.firstName} ${val.lastName}`,
          })
        }
        this.$message.success({
          title: 'Success',
          content: `The Editoral Board has been ${handle.toLowerCase()}!`,
        })
        this.getList()
      })
    },
    async detail(val) {
      if (val.handle === 'UNHANDLED') {
        this.edit(val)
      } else {
        this.isVisableDetail = true
        this.inputData = await eboardApply.query(val.id, {
          journalId: this.params.journalId,
        })
      }
    },
    changeJournal(val) {
      this.getList()
      localStorage.setItem('journalId', val)
    },
    confirm() {
      this.getList()
      this.isVisable = false
    },
    cancel() {
      this.isVisable = false
      this.isVisableDetail = false
      this.showSendEmail = false
    },
    // 发送邮件
    sendEmail(val) {
      this.inputData = {
        applyEboardId: val.id,
        journalId: this.params.journalId,
      }
      this.showSendEmail = true
    },
    async send() {
      await eboardApply.acceptedById(
        this.emailData.id,
        Object.assign(this.updateDate, {
          handle: this.emailHandle,
          journalId: this.params.journalId,
        })
      )
      this.$message.success({
        title: 'Success',
        content: `The Editoral Board has been ${this.emailHandle.toLowerCase()}!`,
      })
      this.getList()
      this.cancel()
    },
  },
}
